
import '$src/styles/datatables.css'

import BankIcon from '@mui/icons-material/AccountBalance'

import React, { Fragment as F, useContext, useEffect, useState } from 'react'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'

import {
  Link,
  useParams,
} from "react-router-dom"

import _TabPanel from '@mui/lab/TabPanel'

import {
  C,
  logg,
  apiRouter,
  appRouter,
} from "$shared"

import {
  AppCtx,
} from '$src/App'
import {
  QueriesCtx,
} from '$src/components/queries'
import {
  SchedulesCtx,
} from '$src/components/schedules'
import {
  BanksCtx,
} from './'

/**
 * BanksIndexTable
**/
const BanksIndexTable = (props) => {
  // logg(props, 'BanksIndexTable')
  // const {
  //   banks,
  // } = props

  const params = useParams()

  /* state */

  const [ banks, setBanks ]     = useState(props.banks)
  const [ sortKey, setSortKey ] = useState('name_i')
  const [ sortDir, setSortDir ] = useState(C.asc)

  const {
    selectedBanks, setSelectedBanks,
    sortedResults, setSortedResults,
  } = useContext(BanksCtx)
  // logg(useContext(BanksCtx), 'BanksCtx in BanksIndexTable')

  const toggleSelectedBank = (which) => {
    const _tmp = { ...selectedBanks }
    if (_tmp[which.rssd]) {
      delete _tmp[which.rssd]
    } else {
      _tmp[which.rssd] = which.rssd
    }
    setSelectedBanks(_tmp)
  }

  /* ctx */

  const {
    actionName, setActionName,
    breadcrumbsActions, setBreadcrumbsActions,
  } = useContext(AppCtx)
  // logg(useContext(AppCtx), 'AppCtx in BanksIndexTable')

  const {
    list,           setList,
    listsModalOpen, setListsModalOpen,
    queryModalOpen, setQueryModalOpen,
  } = useContext(QueriesCtx)

  const {
    oneResultTitle, setOneResultTitle,
  } = useContext(SchedulesCtx)

  /* effects */

  /* sort */
  useEffect(() => {
    const tmp = [...props.banks]

    tmp.sort((a, b) => {
      if (a.kind !== 'bank' && b.kind === 'bank') {
        return -1
      }
      if (a.kind === 'bank' && b.kind !== 'bank') {
        return 1
      }
      if (a[sortKey] < b[sortKey]) {
        return sortDir === C.asc ? -1 : 1
      } else {
        return sortDir === C.asc ? 1 : -1
      }
    })
    setSortedResults(tmp)
    setBanks(tmp)
  }, [ sortKey, sortDir, props.banks ])

  /* set one result title */
  useEffect(() => {
    if ([ C.actions['banks#results'], C.lists_actions.modify, C.queries_actions.create ].indexOf(actionName)!==-1) {
      setOneResultTitle(null)
      if (Object.keys(selectedBanks).length &&
          Object.keys(selectedBanks).join('').indexOf('id') === -1) {

        setBreadcrumbsActions(<div className='d-flex' id='test--onlyBanksSelected' >
          &nbsp;&nbsp;&nbsp;<div className='Btn btn-primary' onClick={() => {
            setActionName(C.lists_actions.add_to_new)
            setList({ name: '' })
            setQueryModalOpen(true)
          } } >Create New List</div>
          &nbsp;&nbsp;&nbsp;
          <div className='Btn btn-primary' onClick={() => {
            setActionName(C.lists_actions.add_to_existing)
            setListsModalOpen(true)
          } } >Add to existing</div>
          &nbsp;&nbsp;&nbsp;
          <div className='Btn btn-primary' onClick={() => {
            setActionName(C.lists_actions.remove_from_existing)
            setListsModalOpen(true)
          } } >Remove from existing</div>
        </div>)
      } else {
        setBreadcrumbsActions(<div className='d-flex' >
          &nbsp;&nbsp;&nbsp;<div className='Btn btn-disabled'>Create New List</div>
          &nbsp;&nbsp;&nbsp;
          <div className='Btn btn-disabled'>Add to existing</div>
        </div>)
      }
    }
  }, [ selectedBanks, window.location.href, actionName ])

  return <F>
    <div className='dt-container'><table className='bordered BanksIndexTable dataTable' >
      <thead>
        <tr>
          <td className='selectable' ><input type='checkbox'
            checked={Object.keys(selectedBanks).length === banks.length}
            ref={(input) => {
              if (!input) return;
              if (Object.keys(selectedBanks).length && Object.keys(selectedBanks).length !== banks.length) {
                input.indeterminate = true
              } else {
                input.indeterminate = false
              }
            } }

            onChange={() => {
              if (Object.keys(selectedBanks).length === banks.length) {
                setSelectedBanks({})
              } else {
                const tmp = {}
                banks.map( b => tmp[b.rssd] = b.rssd )
                setSelectedBanks(tmp)
              }
          } } /></td>
          <td className={`bank-name dt-orderable-asc dt-orderable-desc ${sortKey === 'name_i' ? sortDir === C.asc ? 'dt-ordering-asc' : 'dt-ordering-desc' : ''}`}
            onClick={() => {
              setSortKey('name_i')
              if (sortKey === 'name_i') {
                setSortDir(sortDir === C.asc ? C.desc : C.asc)
              }
            } }
          >Name<span className='dt-column-order'></span>
          </td>
          <td className={`cert dt-orderable-asc dt-orderable-desc ${sortKey === 'cert_num' ? sortDir === C.asc ? 'dt-ordering-asc' : 'dt-ordering-desc' : ''}`}
            onClick={() => {
              setSortKey('cert_num')
              if (sortKey === 'cert_num') {
                setSortDir(sortDir === C.asc ? C.desc : C.asc)
              }
            } }
          >Cert<span className='dt-column-order'></span>
          </td>
          <td className={`city dt-orderable-asc dt-orderable-desc ${sortKey === 'city' ? sortDir === C.asc ? 'dt-ordering-asc' : 'dt-ordering-desc' : ''}`}
            onClick={() => {
              setSortKey('city')
              if (sortKey === 'city') {
                setSortDir(sortDir === C.asc ? C.desc : C.asc)
              }
            } }
          >City<span className='dt-column-order'></span>
          </td>
          <td className={`state dt-orderable-asc dt-orderable-desc ${sortKey === 'state' ? sortDir === C.asc ? 'dt-ordering-asc' : 'dt-ordering-desc' : ''}`}
            onClick={() => {
              setSortKey('state')
              if (sortKey === 'state') {
                setSortDir(sortDir === C.asc ? C.desc : C.asc)
              }
            } }
          >State<span className='dt-column-order'></span>
          </td>
          <td className={`total-assets dt-orderable-asc dt-orderable-desc ${sortKey === 'total_assets_num' ? sortDir === C.asc ? 'dt-ordering-asc' : 'dt-ordering-desc' : ''}`}
            onClick={() => {
              setSortKey('total_assets_num')
              if (sortKey === 'total_assets_num') {
                setSortDir(sortDir === C.asc ? C.desc : C.asc)
              }
            } }
          >Total Assets (000's)<span className='dt-column-order'></span>
          </td>
        </tr>
      </thead>
      <tbody>
        { banks.map((bank, idx) => <tr key={idx} >
          <td>
            <input type='checkbox'
              checked={!!selectedBanks[bank.rssd]}
              onChange={() => toggleSelectedBank(bank)}
            />
          </td>
          <td data-rssd={bank.rssd} >
            <OverlayTrigger placement="right"
              overlay={<Tooltip>Financial data view</Tooltip>}
            ><F>
              <Link to={ appRouter.bankSchedulePath({ bank_rssd: bank.rssd, schedule_id: 'ORGPROF' }) }
              >{bank.name}</Link>
              { bank.kind === 'list' ? " (LM)" : null }
              { bank.kind === 'query' ? " (QM)" : null }
            </F></OverlayTrigger>
          </td>
          <td>{bank.cert}</td>
          <td>{bank.city}</td>
          <td>{bank.state}</td>
          <td className='total-assets'>{bank.total_assets}</td>
        </tr> )}
      </tbody>
    </table></div>

    <br />
  </F>
}

export default BanksIndexTable
